import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

// Components
import Heading from '../Heading';
import Amount from '../Amount';
import VariationInfo from '../VariationInfo';
import Button from '../Button';

// Icons
import Gift from '../../icons/gift.svg';

// Styles
import styles from './ReplacementSlider.styl';

const cx = classNames.bind(styles);

export default function ReplacementSlide(props) {
  const { addToCart, image, name, price, id, isBonus, type, sku, points, count } = props;

  const addToCartHandler = () => {
    const composition = new Array(count).fill({ type, item: props });
    const goodId = isBonus ? sku : id;

    addToCart(goodId, composition);
  };

  return (
    <>
      <figure className={cx('ReplacementSlide__slide-image')}>
        <img src={image} alt="Good" />
      </figure>
      <div className={cx('ReplacementSlide__slide-group')}>
        <Heading className={cx('ReplacementSlide__slide-name')} level={5} tagName="h6">
          {name}
        </Heading>
        <VariationInfo {...props} className={cx('ReplacementSlide__slide-description')} />
        <div className={cx('ReplacementSlide__slide-footer')}>
          <Amount value={isBonus ? points : price} size="s" bonus={isBonus} />
          {isBonus ? (
            <Button onClick={addToCartHandler} small>
              <Gift width={18} height={18} />
            </Button>
          ) : (
            <button
              type="button"
              className={cx('ReplacementSlide__slide-footer__button')}
              onClick={addToCartHandler}
            >
              <FormattedMessage id="button.replace" />
            </button>
          )}
        </div>
      </div>
    </>
  );
}

ReplacementSlide.defaultProps = {
  className: '',
  isAdding: false,
  old_price: null,
  isBonus: false,
  sku: 0,
  points: 0,
};

ReplacementSlide.propTypes = {
  className: PropTypes.string,
  isAdding: PropTypes.bool,
  addToCart: PropTypes.func.isRequired,
  image: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  old_price: PropTypes.number,
  type: PropTypes.string.isRequired,
  isBonus: PropTypes.bool,
  sku: PropTypes.number,
  points: PropTypes.number,
  count: PropTypes.number.isRequired,
};
